export interface PasswordRequirements {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialCharacter: boolean;
}

export interface UsePasswordRequirementsReturn {
  requirements: PasswordRequirements;
  isValid: boolean;
}

const MIN_LENGTH: number = 8;
const MAX_LENGTH: number = 20;

const UPPERCASE_REGEX: RegExp = /[A-Z]/;
const LOWERCASE_REGEX: RegExp = /[a-z]/;
const NUMBER_REGEX: RegExp = /\d/;
const SPECIAL_CHARACTER_REGEX: RegExp = /[!@#$%^&*)(+=._-]/;

export const usePasswordRequirements = (
  password: string
): UsePasswordRequirementsReturn => {
  const trimmed: string = password.trim();

  const requirements: PasswordRequirements = {
    hasMinLength: trimmed.length >= MIN_LENGTH && trimmed.length <= MAX_LENGTH,
    hasUppercase: UPPERCASE_REGEX.test(trimmed),
    hasLowercase: LOWERCASE_REGEX.test(trimmed),
    hasNumber: NUMBER_REGEX.test(trimmed),
    hasSpecialCharacter: SPECIAL_CHARACTER_REGEX.test(trimmed),
  };

  const isValid: boolean =
    requirements.hasMinLength &&
    requirements.hasUppercase &&
    requirements.hasLowercase &&
    requirements.hasNumber &&
    requirements.hasSpecialCharacter;

  return { requirements, isValid };
};
